module.exports = __webpack_public_path__ + "d261f993c528afd563f782895a619c5a.jpg";